import { COLORS } from "../constants/colors";

export const THEME = {
  light: {
    page: COLORS.WHITE,
    pageSecondary: COLORS.GREY[50],
    primary: COLORS.BLUE[500],
    secondary: COLORS.GREY[100],
    success: COLORS.GREEN[400],
    danger: COLORS.RED[500],
    warning: COLORS.ORANGE[500],
    border: {
      primary: COLORS.GREY[100],
      secondary: COLORS.GREY[500],
    },
    text: {
      primary: COLORS.GREY[900],
      secondary: COLORS.GREY[600],
    },
    glass: {
      background: "rgba(245, 245, 247, 0.75)",
      border: "rgba(229, 231, 235, 0.4)",
      blur: "12px",
    },
  },
  dark: {
    page: COLORS.GREY[900],
    pageSecondary: COLORS.GREY[950],
    primary: COLORS.BLUE[500],
    secondary: COLORS.GREY[800],
    success: COLORS.GREEN[400],
    danger: COLORS.RED[400],
    warning: COLORS.ORANGE[400],
    border: {
      primary: COLORS.GREY[800],
      secondary: COLORS.GREY[500],
    },
    text: {
      primary: COLORS.GREY[50],
      secondary: COLORS.GREY[300],
    },
    glass: {
      background: "rgba(25, 25, 25, 0.65)",
      border: "rgba(60, 60, 60, 0.4)",
      blur: "12px",
    },
  },
};
